import { defineMessages } from 'react-intl';

export const scope = 'app.components.PartnerDetailsModal';

export default defineMessages({
  missingRehire: {
    id: `${scope}.missingRehire`,
    defaultMessage:
      'No Workday rehire value found. Please check eligibility evaluation.',
    description:
      "Tells a recruiter the rehire value that would have set this background check's validity window is missing, above the sentence naming the window it fell back to",
  },
  expiresOn: {
    id: `${scope}.expiresOn`,
    defaultMessage: 'Background check expires on {date}',
    description:
      'Names the first day a passing background check can no longer be reused, above the details of the package it was run under',
  },
  expiresOnWithDays: {
    id: `${scope}.expiresOnWithDays`,
    defaultMessage:
      'Background check expires on {date} ({daysRemaining, plural, one {# day left} other {# days left}})',
    description:
      'Names the first day a passing background check can no longer be reused and how many days are left before it, above the details of the package it was run under',
  },
  expiredOn: {
    id: `${scope}.expiredOn`,
    defaultMessage:
      'The last valid background check expired on {date} — new check required',
    description:
      'Tells a recruiter the newest passing background check on file is no longer valid and a new one has to be run, with the day it stopped being valid',
  },
  // Wording pending the customer's confirmation. The `id` is permanent once merged; `defaultMessage` is not.
  reusedFrom: {
    id: `${scope}.reusedFrom`,
    defaultMessage: 'Previous background check found based on name, date of birth and SSN',
    description:
      'Tells a recruiter this check was reused from a previous application rather than run for this one, under the expires-on/expired-on line',
  },
});
